import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {logout} from '../utils';
import {TokenService} from '../../core/api/token/token.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  constructor(private router: Router,
              public tokenService: TokenService) { }

  ngOnInit(): void {
  }

  logout(): void {
    logout();
    this.router.navigate(['/login']);
  }

}
